import { useLang } from "@/contexts/LangContext";
import Reveal from "@/components/Reveal";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/0ymt0tjh_IMG_1787.jpeg";
const ENV_IMGS = [
  "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?auto=format&fit=crop&w=1200&q=85",
  "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/r4ku89z7_IMG_2239.png",
  "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=85",
];
const SECONDARY =
  "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&w=1800&q=85";

const PARTNERS = [
  { name: "Kenoa Exclusive Beach Spa & Resort", src: "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/4vym9nhe_be2a9637-3b9d-42af-b18b-63dd43e3d0ca.jpeg" },
  { name: "Organomix", src: "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/20dq30qx_IMG_2931.jpeg" },
  { name: "Bota NY", src: "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/pzv8jsz8_dab8784f-fcc9-4de0-9cf9-e19272815ebb.jpeg" },
  { name: "La Prairie Switzerland", src: "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/8q08v8nt_6e271204-ae96-4004-9b65-fc9d9937f628.jpeg" },
  { name: "Ananda in the Himalayas", src: "https://customer-assets.emergentagent.com/job_web-essentials-21/artifacts/aj9d81gr_IMG_2930.jpeg" },
];

export default function About() {
  const { t } = useLang();

  return (
    <div data-testid="page-about" className="bg-[#070E13] text-[#F4EEE8]">
      {/* HERO */}
      <section className="bg-[#070E13] text-[#F4EEE8] pt-40 pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <Reveal className="lg:col-span-7">
            <p className="overline gold-text">{t.about.eyebrow}</p>
            <h1 className="h-editorial text-5xl sm:text-6xl lg:text-7xl mt-6">{t.about.title}</h1>
            <p className="mt-8 text-lg text-[#D6D1C9] max-w-2xl leading-relaxed">{t.about.lead}</p>
          </Reveal>
          <Reveal delay={150} className="lg:col-span-5">
            <div className="grid grid-cols-3 gap-px bg-[#C7A26C]/20 border border-[#C7A26C]/25">
              {t.about.stats.map((s, i) => (
                <div key={i} className="relative bg-[#070E13] p-5">
                  <span className="absolute top-0 left-0 w-8 h-px bg-[#C7A26C]/70" />
                  <p className="font-serif text-4xl gold-text">{s.k}</p>
                  <p className="text-xs text-[#D6D1C9] mt-3 leading-snug">{s.v}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* PORTRAIT + STORY (dark continuation) */}
      <section className="bg-[#0C1821] py-24 sm:py-32 border-y border-[#C7A26C]/15">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <img
                src={PORTRAIT}
                alt="Carol Stoffella"
                className="w-full aspect-[4/5] object-cover"
                style={{ filter: "brightness(0.88) contrast(1.05) saturate(0.92)" }}
              />
              {/* Dark navy tint to merge with site */}
              <div className="absolute inset-0 mix-blend-multiply opacity-25" style={{ background: "linear-gradient(180deg, rgba(7,14,19,0.10), rgba(7,14,19,0.45))" }} />
              {/* Warm champagne edge wash */}
              <div className="absolute inset-0 mix-blend-overlay opacity-30" style={{ background: "linear-gradient(135deg, rgba(199,162,108,0.18), rgba(7,14,19,0.20))" }} />
              <span className="absolute -top-2 -left-2 w-10 h-px bg-[#C7A26C]" />
              <span className="absolute -top-2 -left-2 w-px h-10 bg-[#C7A26C]" />
              <span className="absolute -bottom-2 -right-2 w-10 h-px bg-[#C7A26C]" />
              <span className="absolute -bottom-2 -right-2 w-px h-10 bg-[#C7A26C]" />
              {/* Caption ribbon */}
              <div className="absolute bottom-3 left-3 right-3 bg-[#070E13]/80 backdrop-blur-sm border border-[#C7A26C]/40 px-4 py-3">
                <p className="overline gold-text text-[0.62rem]">{t.about.portraitCaption}</p>
                <p className="font-serif text-lg text-[#F4EEE8] mt-1">Carol Stoffella</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={150} className="lg:col-span-7 space-y-6 text-[#D6D1C9] text-lg leading-relaxed">
            {t.about.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <div className="pt-8 mt-8 border-t border-[#C7A26C]/25">
              <p className="overline gold-text">{t.about.identity.title}</p>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-3 font-serif text-xl text-[#F4EEE8]">
                {t.about.identity.items.map((it, i) => (
                  <li key={i} className="flex gap-3 items-start">
                    <span className="text-[#C7A26C] mt-2">—</span> {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      {/* SELECTED COLLABORATIONS & PARTNERSHIPS — monochrome, breathing space, Aman/Six Senses style */}
      <section data-testid="about-partners" className="bg-[#070E13] py-24 sm:py-36 border-b border-[#C7A26C]/10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <Reveal>
            <div className="text-center max-w-3xl mx-auto">
              <p className="overline tracking-[0.32em] text-[#C7A26C]/80">{t.about.partners.eyebrow}</p>
              <h2 className="h-editorial text-3xl sm:text-4xl lg:text-5xl mt-6 text-[#F4EEE8]/95 leading-[1.15]">
                {t.about.partners.title}
              </h2>
              <span aria-hidden className="block mx-auto mt-10 w-12 h-px bg-[#C7A26C]/50" />
            </div>
          </Reveal>

          {/* Logos — horizontal, monochrome off-white, generous breathing space */}
          <div className="mt-20 sm:mt-24 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-y-16 gap-x-10 sm:gap-x-14 items-center">
            {PARTNERS.map((p, i) => (
              <Reveal key={p.name} delay={i * 100} className="flex items-center justify-center">
                <div
                  className="relative w-full h-16 sm:h-20 flex items-center justify-center transition-all duration-700 opacity-70 hover:opacity-100"
                  title={p.name}
                >
                  <img
                    src={p.src}
                    alt={p.name}
                    loading="lazy"
                    className="max-h-full max-w-[80%] object-contain transition-all duration-700"
                    style={{
                      filter: "grayscale(1) invert(1) contrast(1.45) brightness(1.05)",
                      mixBlendMode: "lighten",
                    }}
                  />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ENVIRONMENTS — where the practice unfolds */}
      <section className="bg-[#0C1821] py-24 sm:py-32 border-b border-[#C7A26C]/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <div className="max-w-3xl">
            <Reveal>
              <p className="overline gold-text">{t.about.environments.eyebrow}</p>
              <h2 className="h-editorial text-4xl sm:text-5xl mt-5">{t.about.environments.title}</h2>
              <p className="mt-6 text-[#D6D1C9] leading-relaxed">
                {t.about.environments.lead}
              </p>
            </Reveal>
          </div>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
            {t.about.environments.items.map((label, i) => (
              <Reveal key={i} delay={i * 100} className="relative aspect-[4/5] overflow-hidden border border-[#C7A26C]/15 group">
                <img src={ENV_IMGS[i]} alt={label} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#070E13] via-[#070E13]/40 to-transparent" />
                <div className="absolute inset-0 mix-blend-overlay opacity-50" style={{ background: "linear-gradient(135deg, rgba(201,166,107,0.20), rgba(7,43,58,0.4))" }} />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="block w-10 h-px bg-[#C7A26C] mb-3" />
                  <p className="font-serif text-2xl">{label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CLOSING QUOTE */}
      <section className="bg-[#070E13] text-[#F4EEE8] py-24 sm:py-32 relative overflow-hidden">
        <img src={SECONDARY} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#070E13]/90 via-[#070E13]/85 to-[#070E13]" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, rgba(201,166,107,0.06), transparent 60%)" }} />
        <div className="relative max-w-5xl mx-auto px-6 text-center">
          <Reveal>
            <span className="block w-12 h-px bg-[#C7A26C] mx-auto mb-8" />
            <p className="font-serif text-3xl sm:text-4xl lg:text-5xl italic leading-snug">
              "{t.about.closing.quote}"
            </p>
            <p className="mt-8 overline gold-text">{t.about.closing.by}</p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
